import { render, staticRenderFns } from "./SuperPaper.vue?vue&type=template&id=41ab07e5"
import script from "./SuperPaper.vue?vue&type=script&lang=js"
export * from "./SuperPaper.vue?vue&type=script&lang=js"
import style0 from "./SuperPaper.vue?vue&type=style&index=0&id=41ab07e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports